export default "__VITE_ASSET__DJ2rjVjo__"